import { useState } from 'react';
import { Percent } from 'lucide-react';
import { getVat, setVat } from '../lib/vat';

export default function VatSetting({ t }) {
  const [v, setV] = useState(String(getVat()).replace('.', ','));
  const save = (s) => { setV(s); const n = parseFloat(s.replace(',', '.')); if (!Number.isNaN(n) && n >= 0 && n <= 100) setVat(n); };
  return (
    <section className="set-sec" data-testid="vat-setting">
      <h5><Percent size={14} /> {t.vatTitle}</h5>
      <div className="row price-row">
        <span className="price-name">{t.vatRate}</span>
        <input type="text" inputMode="decimal" data-testid="vat-rate-input" value={v} onChange={(e) => save(e.target.value)} />
      </div>
      <p className="muted small-hint">{t.vatHint}</p>
    </section>
  );
}
